import { useSearchParams } from 'react-router';

import { LocalStorageKey, localStorageUtil } from '@/utils/localStorage/localStorage.util.ts';

export const useCustomTableInitialParamsSetter = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  return {
    customTableInitialParamsSetter: (params: { tableSubKey: string; value: string }) => {
      const { tableSubKey, value } = params;
      const newSearchParams = new URLSearchParams(searchParams.toString());
      newSearchParams.delete(tableSubKey);
      setSearchParams(newSearchParams);
      localStorageUtil.setItem({
        key: LocalStorageKey.CUSTOM_TABLE,
        subKey: tableSubKey,
        value,
      });
    },
  };
};
